import { render, staticRenderFns } from "./VideoChips.vue?vue&type=template&id=1367b55c&scoped=true&"
import script from "./VideoChips.vue?vue&type=script&lang=js&"
export * from "./VideoChips.vue?vue&type=script&lang=js&"
import style0 from "./VideoChips.vue?vue&type=style&index=0&id=1367b55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1367b55c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
